import { Navigate, useLocation } from 'react-router-dom';

/** Moves a bookmarked URL to its new path, keeping its query and hash. */
export default function MovedTo({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
